
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import wx from 'weixin-js-sdk';
	import Util from '@/lib/util';
	import AbpBase from '@/lib/abpbase';
	import QuestionTpl from '@/store/entities/questiontpl'
	import QuestionTplDet from '@/store/entities/questiontpldet'
	import QuestionTplDetValue from '@/store/entities/questiontpldetvalue'

	import videojs from 'video.js';
	import 'viewerjs/dist/viewer.css'
	@Component({
		components: {

		}
	})
	export default class TestQuestion extends AbpBase {
		qid: number = 0;
		questionTpl: QuestionTpl = new QuestionTpl();

		detValueList: Array < QuestionTplDetValue >= new Array < QuestionTplDetValue > ();
		detList: Array < QuestionTplDet >= new Array < QuestionTplDet > ();
		disabled: boolean = false;
		showShare:boolean=false;
		msg: string = '';
		userAgent: string = "";
		
		share() {
			this.showShare = true;		
		}
		isIos() {
			var u = navigator.userAgent.toLowerCase();
			this.userAgent = u;
			if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1 || u.indexOf("mac") > -1) {
				return true;
			}
			return false;
		}
		shareToWeixin(shareWeixinType) {
			var that = this;
			var questionTpl = (this.questionTpl as any);
			var title = questionTpl.name;
			var link = location.protocol + "//" + location.host + "/#/questionnaireuser?qid=" + questionTpl.id;
			var content = questionTpl.desc;
			var coverImg = questionTpl.pic;
			if (content == '') {
				content = title;
				title = '';
			}
			if (that.isIos()) {
				if(coverImg!=null &&coverImg.length>0 && Util.abp.session.userId!=null){
					that.$store.dispatch({
						type: 'app/refreshOSSPresignedUri',
						data: {
							url: coverImg,
							process: 'image/resize,m_fixed,w_30,h_30'
						}
					}).then(res => {
						coverImg = res;
						that.gisShareToWeixin(title, content, link, coverImg, shareWeixinType);
					});
				}
				else{
					that.gisShareToWeixin(title, content, link, coverImg, shareWeixinType);
				}
				
			} else {
				that.gisShareToWeixin(title, content, link, coverImg, shareWeixinType);
			}
		
		}
		gisShareToWeixin(title, content, link, coverImg, shareWeixinType) {
			var that = this;
			// shareWeixinType: string = "WXSceneSession" // WXSceneTimeline
			(window as any).gis.shareToWeixin({
				type: 'web',
				title: title,
				content: content,
				href: link,
				thumbs: [coverImg],
				extra: {
					scene: shareWeixinType
				},
				// pictures:[news.coverImg],
				success: function() {
					that.showShare = false;
					//that.createNewsOperation(3);
				},
				fail: function() {
					that.showShare = false;
				}
			})
		}
		isWeiXin() {
			var ua = navigator.userAgent.toLowerCase() as any;
			this.userAgent = ua;
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true; // 是微信端
			} else {
				return false;
			}
		}
		weixinShare() {
			var that = this;
			if (this.isWeiXin()) {
				var questionTpl = that.questionTpl as any;
				var url = location.href.split('#')[0];
				that.msg = that.msg + 'is weixin';
				this.$store.dispatch({
					type: 'app/getWeixinJSSDKConfig',
					data: {
						url: url
					}
				}).then(res => {
					var config = res;
					wx.config({
						debug: false,
						appId: config.appId, // 必填，公众号的唯一标识
						timestamp: config.timestamp, // 必填，生成签名的时间戳
						nonceStr: config.nonceStr, // 必填，生成签名的随机串
						signature: config.signature, // 必填，签名
						jsApiList: ['checkJsApi',
							'onMenuShareTimeline',
							'onMenuShareAppMessage',
						] // 必填，需要使用的JS接口列表
					});
					that.msg = that.msg + ' configed';
					wx.ready(function() { //需在用户可能点击分享按钮前就先调用
						that.msg = that.msg + ' ready';
						wx.updateAppMessageShareData({
							title: questionTpl.name, // 分享标题
							desc: questionTpl.desc, // 分享描述
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: questionTpl.pic, // 分享图标
							success: function() {
								// 设置成功
		
							}
						})
						wx.onMenuShareAppMessage({
							title: questionTpl.name, // 分享标题
							desc: questionTpl.desc, // 分享描述
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: questionTpl.pic, // 分享图标
							type: "link", // 分享类型,music、video或link，不填默认为link
							dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
							success: function() {
								// 用户点击了分享后执行的回调函数
							},
							cancel:function(){
								
							}
						});
						wx.onMenuShareTimeline({
							title: questionTpl.name, // 分享标题
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: questionTpl.pic, // 分享图标
							success: function() {
								// 用户点击了分享后执行的回调函数
							},
							cancel:function(){
								
							}

						});
						wx.updateTimelineShareData({
							title: questionTpl.name, // 分享标题
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: questionTpl.pic, // 分享图标
							success: function() {
								// 设置成功
							},
							cancel:function(){
								
							}
						})
					});
		
				})
			}
		
		}
		
		

		saveQuestion(index) {
			var that = this;
			var isRequired = "";
			var det = that.detValueList[index];
			var detid = det.id;
			that.detList[0].content = detid.toString();
			that.questionTpl.questionTplDetList = that.detList;
			that.questionTpl.users = null;
			that.questionTpl.organizations = null;
			that.questionTpl.createUser = null;

			this.$Message.loading({
				content: this.L("保存中"),
				duration: 3
			});
			that.disabled = true;
			that.questionTpl.users = null;
			that.questionTpl.organizations = null;
			that.questionTpl.createUser = null;
			that.$store.dispatch({
				type: 'app/createQuestionUser',
				data: that.questionTpl
			}).then((res) => {
				that.$Message.destroy();
				that.$Message.success(this.L('VotedSuccess'));
				that.detValueList[index].isChecked = true;
				that.detValueList[index].totalCount = that.detValueList[index].totalCount + 1;
				//this.$forupdate();
			}).catch(res => {
				that.disabled = false;
			});

		}


		getQuestionTplById() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getQuestionTplById',
				id: this.qid
			}).then((res) => {
				console.log(res);
				that.questionTpl = res;
				that.detList = that.questionTpl.questionTplDetList;

				if (that.detList.length > 0) {
					that.detValueList = that.detList[0].questionTplDetValueList;
				}
				that.weixinShare();
				console.log(that.detValueList);
			})
		}

		@Watch('$route')
		routechange(to: any, from: any) {
			if (to.query.qid != from.query.qid) {
				location.reload();
			}
		}


		abstract
		async created() {
			console.log(Util.abp.session.userId);
			if (!Util.abp.session.userId) {
				var domain = this.$route.query.domain as any;
				if (domain != undefined && domain != null && domain != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSDOMAIN",
							"ProviderAccessCode": domain,
							ProviderKey: "",
							Property: ""
						},
					})
					location.reload();
				}
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSID",
							"ProviderAccessCode": userId,
							ProviderKey: userId,
							Property: ""
						},
					})
					location.reload();
				}
			}
			if (this.$route.query.qid && (this.$route.query.qid as any) > 0) {
				this.qid = this.$route.query.qid as any;

				this.getQuestionTplById();
			} else {

			}
		}
	}
